var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10252_2915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10252_2915",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10252_2915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.355 1.21875C9.99049 1.21875 6.43015 4.79127 6.43015 9.1557C6.43015 11.8244 7.76428 14.1876 9.79689 15.6254C5.05805 17.5242 1.69629 22.1576 1.69629 27.5639C1.70354 27.8906 1.83842 28.2015 2.07205 28.4299C2.30568 28.6584 2.61949 28.7865 2.94629 28.7865C3.27309 28.7865 3.58689 28.6584 3.82052 28.4299C4.05415 28.2015 4.18904 27.8906 4.19629 27.5639C4.19629 21.8263 8.82002 17.2025 14.5576 17.2025C16.5604 17.2025 18.4195 17.7735 20.0019 18.7529C20.1421 18.8401 20.298 18.8988 20.4608 18.9256C20.6237 18.9525 20.7901 18.9468 20.9509 18.9092C21.1115 18.8716 21.2632 18.8026 21.3972 18.7064C21.5312 18.61 21.6448 18.4882 21.7317 18.3479C21.8186 18.2076 21.8769 18.0516 21.9033 17.8887C21.9298 17.7258 21.9239 17.5592 21.8858 17.3987C21.8479 17.2381 21.7786 17.0866 21.6819 16.9528C21.5853 16.8191 21.4633 16.7056 21.3228 16.6191C20.6097 16.1778 19.8357 15.8323 19.0376 15.5351C21.0037 14.0899 22.292 11.7704 22.292 9.1557C22.292 4.79127 18.7194 1.21875 14.355 1.21875ZM14.355 3.7211C17.3684 3.7211 19.7895 6.14234 19.7895 9.1557C19.7895 12.1691 17.3684 14.5805 14.355 14.5805C11.3416 14.5805 8.93017 12.1691 8.93017 9.1557C8.93017 6.14234 11.3416 3.7211 14.355 3.7211Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0627 19.9453C20.7925 19.9453 18.9495 21.7883 18.9495 24.0586C18.9495 26.3289 20.7925 28.173 23.0627 28.173C25.333 28.173 27.1772 26.3289 27.1772 24.0586C27.1772 21.7883 25.333 19.9453 23.0627 19.9453ZM23.0627 21.6775C24.3769 21.6775 25.445 22.7445 25.445 24.0586C25.445 25.3727 24.3769 26.4409 23.0627 26.4409C21.7486 26.4409 20.6805 25.3727 20.6805 24.0586C20.6805 22.7445 21.7486 21.6775 23.0627 21.6775Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9287 20.8142V18.8661C23.9287 18.388 23.5407 18 23.0626 18C22.5845 18 22.1965 18.388 22.1965 18.8661V20.8153C22.1965 21.2922 22.5845 21.6814 23.0626 21.6814C23.5407 21.6802 23.9287 21.2922 23.9287 20.8142Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9715 22.38L27.3491 21.0012C27.6875 20.6641 27.6875 20.1144 27.3491 19.7772C27.012 19.4389 26.4623 19.4389 26.1251 19.7772L24.7463 21.1548C24.4091 21.4932 24.4091 22.0417 24.7463 22.38C25.0846 22.7172 25.6332 22.7172 25.9715 22.38Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.31 24.9275H28.2592C28.7373 24.9275 29.1253 24.5395 29.1253 24.0614C29.1253 23.5833 28.7373 23.1953 28.2592 23.1953H26.31C25.8331 23.1953 25.4451 23.5833 25.4451 24.0614C25.4439 24.5395 25.8331 24.9275 26.31 24.9275Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7463 26.9703L26.1251 28.3479C26.4623 28.6863 27.012 28.6863 27.3491 28.3479C27.6875 28.0107 27.6875 27.4611 27.3491 27.1239L25.9715 25.7451C25.6332 25.4079 25.0846 25.4079 24.7463 25.7451C24.4091 26.0834 24.4091 26.6319 24.7463 26.9703Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1965 27.3114V29.2606C22.1965 29.7387 22.5845 30.1267 23.0626 30.1267C23.5407 30.1267 23.9287 29.7387 23.9287 29.2606V27.3114C23.9287 26.8345 23.5407 26.4465 23.0626 26.4453C22.5845 26.4453 22.1965 26.8345 22.1965 27.3114Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1534 25.7451L18.7757 27.1239C18.4374 27.4611 18.4374 28.0107 18.7757 28.3479C19.1129 28.6863 19.6626 28.6863 19.9998 28.3479L21.3786 26.9703C21.7158 26.6319 21.7158 26.0834 21.3786 25.7451C21.0402 25.4079 20.4917 25.4079 20.1534 25.7451Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8142 23.1953H17.8661C17.388 23.1953 17 23.5833 17 24.0614C17 24.5395 17.388 24.9275 17.8661 24.9275H19.8142C20.2922 24.9275 20.6814 24.5395 20.6802 24.0614C20.6802 23.5833 20.2922 23.1953 19.8142 23.1953Z",
    fill: "#04385D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3786 21.1548L19.9998 19.7772C19.6626 19.4389 19.1129 19.4389 18.7757 19.7772C18.4374 20.1144 18.4374 20.6641 18.7757 21.0012L20.1534 22.38C20.4917 22.7172 21.0402 22.7172 21.3786 22.38C21.7158 22.0417 21.7158 21.4932 21.3786 21.1548Z",
    fill: "#04385D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10252_2915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmins);
export default __webpack_public_path__ + "static/media/Admins.4a833f818e6520873dd36fbd313e6e48.svg";
export { ForwardRef as ReactComponent };